export const CACHE_TTL = {
  SMALL: 1 * 60 * 1000, // 1 min
  MEDIUM: 5 * 60 * 1000, // 5 min
  LARGE: 10 * 60 * 1000, // 10 min
};
